import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from 'reportWebVitals';
import Navigations from 'navigations';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import { store } from 'redux/store';
import jaJP from 'antd/lib/locale/ja_JP';

import GlobalStyle from 'styles';
import { QueryClient, QueryClientProvider } from 'react-query';
// Create a client
const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ConfigProvider locale={jaJP}>
          <GlobalStyle />
          <Navigations />
        </ConfigProvider>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
